export default "__VITE_ASSET__gFGIfk_J__"